class ContactForm extends HTMLElement {
  constructor() {
    super();

    this.inquiryRadioButtons = this.querySelectorAll('input[name="inquiry"]');
    this.productDefectRadioButtons = this.querySelectorAll('input[name="product-defect"]');
    this.productDefect = this.querySelector('.product-defect');
    this.form1 = this.querySelector('.form-1');
    this.form2 = this.querySelector('.form-2');
    this.form3 = this.querySelector('.form-3');
    this.form4 = this.querySelector('.form-4');
    this.form5 = this.querySelector('.form-5');
    this.inquiryRadioButtons.forEach(radio => {
      radio.addEventListener('change', this.handleSelectInquiry.bind(this));
    });
    this.productDefectRadioButtons.forEach(radio => {
      radio.addEventListener('change', this.handleSelectProductDefect.bind(this));
    });
  }

  handleSelectInquiry(evt) {
    const inquiry = evt.target.value;

    if (inquiry === "商品の不具合に関して") {
      this.productDefect.style.display = "block";
      this.form1.style.display = "none";
      this.form2.style.display = "none";
      this.form3.style.display = "none";
      this.form4.style.display = "none";
      this.form5.style.display = "none";
    } else {
      this.productDefect.style.display = "none";

      if (inquiry === "ご注文前のお問い合わせ") {
        this.form3.style.display = "block";
        this.form1.style.display = "none";
        this.form2.style.display = "none";
        this.form4.style.display = "none";
        this.form5.style.display = "none";
      } else if (inquiry === "ご注文のキャンセル") {
        this.form4.style.display = "block";
        this.form1.style.display = "none";
        this.form2.style.display = "none";
        this.form3.style.display = "none";
        this.form5.style.display = "none";
      } else {
        this.form5.style.display = "block";
        this.form1.style.display = "none";
        this.form2.style.display = "none";
        this.form3.style.display = "none";
        this.form4.style.display = "none";
      }
    }
  }

  handleSelectProductDefect(evt) {
    const productDefect = evt.target.value;

    if (productDefect !== "家電量販店") {
      this.form1.style.display = "block";
      
      this.form2.style.display = "none";
      this.form3.style.display = "none";
      this.form4.style.display = "none";
      this.form5.style.display = "none";
    } else {
      this.form1.style.display = "none";
      this.form2.style.display = "block";
      this.form3.style.display = "none";
      this.form4.style.display = "none";
      this.form5.style.display = "none";
    }
  }
}

customElements.define("contact-form", ContactForm);
